const miniCart = {
  init() {
    this.removeItem();
  },

  removeItem() {
    $(document).on("click", ".remove-cart-item", function (event) {
      event.preventDefault();
      let _self = $(this);

      _self.closest(".cart__item").addClass("cart__item-loading");

      $.ajax({
        url: _self.data("url"),
        method: "GET",
        success: (res) => {
          _self.closest(".cart__item").removeClass("cart__item-loading");

          if (res.error) {
            Theme.showError(res.message);
            return false;
          }

          $.ajax({
            url: window.siteUrl + "/ajax/cart",
            method: "GET",
            success: (response) => {
              if (!response.error) {
                $(".cart__dropdown").replaceWith(response.data.html);
                $(".cart-item-count").text(response.data.count);
                Theme.showSuccess(res.message);
              }
            },
          });
        },
        error: (res) => {
          _self.closest(".cart__item").removeClass("cart__item-loading");
          Theme.showError(res.message);
        },
      });
    });
  },
};

$(function () {
  miniCart.init();
});
